export default {
  computed: {
    parent() {
      let parent = this.$parent
      while (parent && !parent.tableIdSeed) {
        parent = parent.$parent
      }
      return parent
    },
    tableData() {
      return this.parent.tableData
    },
    columns() {
      return this.parent.columns
    }
  },
  methods: {
    getAttrs(item) {
      return { ...item.componentOptions.propsData, ...item.data.attrs }
    }
  }
}
